namespace RedBullMOBILE360.PushNotifications {
    export interface PushNotificationsForm {
        NotificationDate: Serenity.DateEditor;
        Sender: Serenity.StringEditor;
        Status: Serenity.IntegerEditor;
        ExcelFileName: Serenity.StringEditor;
        IsExcelUploaded: Serenity.IntegerEditor;
    }

    export class PushNotificationsForm extends Serenity.PrefixedContext {
        static formKey = 'PushNotifications.PushNotifications';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PushNotificationsForm.init)  {
                PushNotificationsForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(PushNotificationsForm, [
                    'NotificationDate', w0,
                    'Sender', w1,
                    'Status', w2,
                    'ExcelFileName', w1,
                    'IsExcelUploaded', w2
                ]);
            }
        }
    }
}
